var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadSecureFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.516,
    height: 16.199,
    viewBox: "0 0 15.516 16.199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Complete",
    transform: "translate(0.5 0.699)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "upload"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4766",
    "data-name": "Group 4766"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1738",
    "data-name": "Path 1738",
    d: "M3,12.3v5.645a1.613,1.613,0,0,0,1.613,1.613H15.9a1.613,1.613,0,0,0,1.613-1.613V12.3",
    transform: "translate(-3 -4.558)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4765",
    "data-name": "Group 4765",
    transform: "translate(3.952)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Right",
    d: "M7.9,5.926,11.206,2.7l3.306,3.226",
    transform: "translate(-7.9 -2.7)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_175",
    "data-name": "Line 175",
    y1: 9.274,
    transform: "translate(3.306 1.694)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSecureFileIcon);
export default __webpack_public_path__ + "static/media/upload-secure-file-icon.5c04b2f4faa05a2c8253dd1938d42efa.svg";
export { ForwardRef as ReactComponent };